/*
 * Komponenty homepage (sekce home-*).
 * Vše se řídí data-atributy v markupu, žádné hodnoty nejsou zadrátované v kódu.
 * Reinicializuje se i po shopify:section:load, aby fungoval editor.
 */
(function () {
  'use strict';

  function $$(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }
  function num(value, fallback) {
    var n = parseFloat(value);
    return isNaN(n) ? fallback : n;
  }
  function isOn(value) {
    return value !== 'false' && value !== '0';
  }
  function claim(el, key) {
    if (el.dataset[key]) return false;
    el.dataset[key] = '1';
    return true;
  }
  function mq(query) {
    return window.matchMedia(query);
  }

  /* ------------------------------------------------------------------ HERO */
  function initHero(root) {
    if (!claim(root, 'homeHeroInit')) return;
    var slides = $$('.aud-hero__slide', root);
    if (slides.length < 2) return;

    var delay = num(root.dataset.autoplay, 4000);
    var pauseOnHover = isOn(root.dataset.pauseHover);
    var i = 0;
    var timer = null;

    function show(n) {
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === n); });
      i = n;
    }
    function next() { show((i + 1) % slides.length); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() { stop(); if (delay > 0) timer = setInterval(next, delay); }

    show(0);
    if (delay <= 0) return;

    // rozjeď až po načtení obrázků, ať první přechod neposkočí
    var pending = 0;
    slides.slice(1).forEach(function (slide) {
      var img = slide.querySelector('img');
      if (!img || img.complete) return;
      pending++;
      var done = function () {
        img.removeEventListener('load', done);
        img.removeEventListener('error', done);
        if (--pending === 0) start();
      };
      img.addEventListener('load', done);
      img.addEventListener('error', done);
    });
    if (pending === 0) start();

    if (pauseOnHover) {
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
    }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });
  }

  /* ----------------------------------------------------------- PROMO BANNER */
  function initPromo(root) {
    if (!claim(root, 'homePromoInit')) return;
    var slides = $$('.aud-sub__slide', root);
    if (slides.length < 2) return;

    var delay = num(root.dataset.autoplay, 4000);
    var pauseOnHover = isOn(root.dataset.pauseHover);
    var i = 0;
    var timer = null;

    function show(n) {
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === n); });
      i = n;
    }
    function next() { show((i + 1) % slides.length); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() { stop(); if (delay > 0) timer = setInterval(next, delay); }

    if (pauseOnHover) {
      root.addEventListener('mouseenter', function () { if (mq('(hover:hover)').matches) stop(); });
      root.addEventListener('mouseleave', function () { if (mq('(hover:hover)').matches) start(); });
    }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });

    show(0);
    start();
    window.addEventListener('resize', function () { show(i); }, { passive: true });
  }

  /* ---------------------------------------------------------- STORE GALLERY */
  function initStore(root) {
    if (!claim(root, 'homeStoreInit')) return;
    var slides = $$('.aud-store__slide', root);
    if (slides.length < 2) return;

    var delay = num(root.dataset.autoplay, 4000);
    var pauseOnHover = isOn(root.dataset.pauseHover);
    var i = 0;
    var timer = null;

    function isDesktop() { return mq('(min-width: 980px)').matches; }
    function show(n) {
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === n); });
      i = n;
    }
    function next() { show((i + 1) % slides.length); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() { stop(); if (delay > 0) timer = setInterval(next, delay); }

    if (pauseOnHover) {
      root.addEventListener('mouseenter', function () { if (isDesktop()) stop(); }, { passive: true });
      root.addEventListener('mouseleave', function () { if (isDesktop()) start(); }, { passive: true });
    }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });

    show(0);
    start();
  }

  /* ------------------------------------------------------------------ TILES */
  function initTiles(root) {
    if (!claim(root, 'homeTilesInit')) return;
    var viewport = root.querySelector('.aud-cats__viewport');
    var dotsWrap = root.querySelector('.aud-cats__dots');
    if (!viewport || !dotsWrap) return;

    var slides = $$('.aud-cat', viewport);
    if (slides.length < 2) return;

    var mobile = mq('(max-width: 979px)');
    function isMobile() { return mobile.matches; }

    if (!dotsWrap.children.length) {
      slides.forEach(function (_, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', (dotsWrap.dataset.dotLabel || 'Přejít na dlaždici') + ' ' + (i + 1));
        if (i === 0) b.classList.add('is-active');
        dotsWrap.appendChild(b);
      });
    }
    var dots = Array.prototype.slice.call(dotsWrap.children);

    var current = 0;

    // Měříme přes getBoundingClientRect, ne přes offsetLeft – ten je relativní
    // k offsetParentu, kterým scroller (position: static) není.
    function centerOf(el) {
      var r = el.getBoundingClientRect();
      return r.left + r.width / 2;
    }
    function centerTo(i, smooth) {
      var s = slides[i];
      if (!s) return;
      current = i;
      viewport.scrollBy({
        left: centerOf(s) - centerOf(viewport),
        behavior: smooth === false ? 'auto' : 'smooth'
      });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    dots.forEach(function (b, i) {
      b.addEventListener('click', function () { if (isMobile()) centerTo(i); });
    });

    function sync() {
      if (!isMobile()) return;
      var center = centerOf(viewport);
      var best = 0;
      var dist = Infinity;
      slides.forEach(function (sl, i) {
        var d = Math.abs(centerOf(sl) - center);
        if (d < dist) { dist = d; best = i; }
      });
      current = best;
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === best); });
    }
    viewport.addEventListener('scroll', function () {
      if (isMobile()) requestAnimationFrame(sync);
    }, { passive: true });

    // Po změně šířky okna dorovnat na aktuální dlaždici, ne skákat na první
    var recenterRaf = null;
    function recenter() {
      if (!isMobile()) return;
      if (recenterRaf) cancelAnimationFrame(recenterRaf);
      recenterRaf = requestAnimationFrame(function () { centerTo(current, false); });
    }
    if (document.readyState === 'complete') recenter();
    else window.addEventListener('load', recenter, { once: true });
    if (mobile.addEventListener) mobile.addEventListener('change', recenter);
    window.addEventListener('resize', recenter, { passive: true });
  }

  /* ------------------------------------------------------------------ LOGOS */
  function initLogos(scroller) {
    if (!claim(scroller, 'homeLogosInit')) return;

    var rows = $$('.aud-logos__row', scroller);
    if (!rows.length) return;
    if (rows.length === 1) {
      scroller.appendChild(rows[0].cloneNode(true));
      rows = $$('.aud-logos__row', scroller);
    }

    var mobile = mq('(max-width: 749px)');
    var reduced = mq('(prefers-reduced-motion: reduce)');
    var desktopDur = num(scroller.dataset.durationDesktop, 30);
    var mobileDur = num(scroller.dataset.durationMobile, desktopDur * 0.6);
    var rafId = null;

    function apply() {
      rafId = null;
      if (reduced.matches) {
        scroller.style.animationPlayState = 'paused';
        scroller.style.removeProperty('--distance');
        scroller.style.transform = 'translateX(0)';
        return;
      }
      var first = rows[0];
      var width = first ? (first.scrollWidth || first.getBoundingClientRect().width || 0) : 0;
      if (width <= 0) { schedule(); return; }
      scroller.style.setProperty('--distance', width + 'px');
      var desired = mobile.matches ? Math.min(mobileDur, 50) : desktopDur;
      scroller.style.animationDuration = Math.max(0.75, desired) + 's';
    }
    function schedule() {
      if (rafId) return;
      rafId = requestAnimationFrame(apply);
    }

    schedule();
    window.addEventListener('resize', schedule, { passive: true });
    [mobile, reduced].forEach(function (m) {
      if (m.addEventListener) m.addEventListener('change', schedule);
      else if (m.addListener) m.addListener(schedule);
    });
    rows.forEach(function (row) {
      $$('img', row).forEach(function (img) {
        if (img.complete) schedule();
        else {
          img.addEventListener('load', schedule, { once: true });
          img.addEventListener('error', schedule, { once: true });
        }
      });
    });
  }

  /* ------------------------------------------------------------------ CASES */
  /* Jeden režim na všech šířkách: nativní scroll-snap. Dřív se na desktopu
     posouvalo transformem a na mobilu scrollem, takže po změně šířky okna
     zůstala nastavená transformace a sekce se rozsypala. */
  function initCases(root) {
    if (!claim(root, 'homeCasesInit')) return;
    var viewport = root.querySelector('.aud-cases__viewport');
    var track = root.querySelector('.aud-cases__track');
    var dotsWrap = root.querySelector('.aud-cases__dots');
    if (!viewport || !track || !dotsWrap) return;

    var slides = Array.prototype.slice.call(track.children);
    if (!slides.length) return;
    track.style.transform = '';

    var autoMs = num(root.dataset.autoplay, 5000);
    var idx = 0;
    var timer = null;
    var stopped = false;

    if (!dotsWrap.children.length && slides.length > 1) {
      slides.forEach(function (_, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-label', (dotsWrap.dataset.dotLabel || 'Reference') + ' ' + (i + 1));
        b.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
        if (i === 0) b.classList.add('is-active');
        dotsWrap.appendChild(b);
      });
    }
    var dots = Array.prototype.slice.call(dotsWrap.children);

    function stepWidth() {
      var s = slides[0];
      if (!s) return 0;
      var w = s.offsetWidth || s.getBoundingClientRect().width || 0;
      var cs = getComputedStyle(track);
      return w + (parseFloat(cs.columnGap || cs.gap || 0) || 0);
    }
    function setDots(i) {
      dots.forEach(function (d, n) {
        var on = n === i;
        d.classList.toggle('is-active', on);
        d.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }
    function go(i, smooth) {
      var step = stepWidth();
      if (step <= 1) { requestAnimationFrame(function () { go(i, smooth); }); return; }
      idx = Math.max(0, Math.min(i, slides.length - 1));
      viewport.scrollTo({ left: idx * step, behavior: smooth === false ? 'auto' : 'smooth' });
      setDots(idx);
    }
    function next() { go((idx + 1) % slides.length); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      stop();
      if (stopped || autoMs <= 0 || slides.length < 2) return;
      timer = setInterval(next, autoMs);
    }

    dots.forEach(function (b, i) {
      b.addEventListener('click', function () { stop(); go(i); start(); });
    });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    // ruční posun vypne automatické střídání
    function killAuto() { if (!stopped) { stopped = true; stop(); } }
    viewport.addEventListener('pointerdown', killAuto, { passive: true });
    viewport.addEventListener('touchstart', killAuto, { passive: true });

    function syncFromScroll() {
      var step = stepWidth();
      if (step <= 1) return;
      var i = Math.max(0, Math.min(Math.round(viewport.scrollLeft / step), slides.length - 1));
      if (i !== idx) { idx = i; setDots(i); }
    }
    viewport.addEventListener('scroll', function () {
      requestAnimationFrame(syncFromScroll);
    }, { passive: true });

    // po změně šířky okna dorovnat pozici na aktuální slajd
    var resizeRaf = null;
    window.addEventListener('resize', function () {
      if (resizeRaf) cancelAnimationFrame(resizeRaf);
      resizeRaf = requestAnimationFrame(function () { go(idx, false); });
    }, { passive: true });

    go(0, false);
    start();
  }

  /* ------------------------------------------- SERVICE GRID – tečky na mobilu */
  function initGrid(grid) {
    if (grid._dotsInit) return;
    var cards = Array.prototype.slice.call(grid.children).filter(function (el) {
      return el.classList && el.classList.contains('aud-card');
    });
    if (cards.length < 2) return;

    var dots = document.createElement('div');
    dots.className = 'aud-svc-dots';
    cards.forEach(function (_, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', (grid.dataset.dotLabel || 'Přejít na kartu') + ' ' + (i + 1));
      if (i === 0) b.classList.add('is-active');
      dots.appendChild(b);
    });
    grid.insertAdjacentElement('afterend', dots);
    grid._dotsInit = true;

    function updateDots() {
      var center = grid.scrollLeft + grid.clientWidth / 2;
      var best = 0;
      var bestDist = Infinity;
      cards.forEach(function (c, i) {
        var d = Math.abs(c.offsetLeft + c.offsetWidth / 2 - center);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      Array.prototype.forEach.call(dots.children, function (b, n) {
        b.classList.toggle('is-active', n === best);
      });
    }
    grid.addEventListener('scroll', function () { requestAnimationFrame(updateDots); }, { passive: true });
    window.addEventListener('resize', updateDots, { passive: true });
    updateDots();

    dots.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b) return;
      var target = cards[Array.prototype.indexOf.call(dots.children, b)];
      if (!target) return;
      grid.scrollTo({ left: target.offsetLeft - (grid.clientWidth - target.clientWidth) / 2, behavior: 'smooth' });
    });
  }

  function refreshGrids(scope) {
    $$('.aud-grid', scope).forEach(function (grid) {
      if (mq('(max-width: 980px)').matches && getComputedStyle(grid).display.indexOf('flex') !== -1) {
        initGrid(grid);
      }
    });
  }

  /* -------------------------------------------------------------------- INIT */
  function initAll(scope) {
    scope = scope || document;
    $$('[data-home-hero]', scope).forEach(initHero);
    $$('[data-home-promo]', scope).forEach(initPromo);
    $$('[data-home-store]', scope).forEach(initStore);
    $$('[data-home-tiles]', scope).forEach(initTiles);
    $$('.aud-logos__scroller', scope).forEach(initLogos);
    $$('[data-home-cases]', scope).forEach(initCases);
    refreshGrids(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  window.addEventListener('load', function () { refreshGrids(document); }, { once: true });
  window.addEventListener('resize', function () { refreshGrids(document); }, { passive: true });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
